import './co-creation.scss';

class CoCreation {
    constructor (group) {
        this.$group = group;
        this.$allInputs = [].slice.call(this.$group.querySelectorAll('input[type="checkbox"]'));
        this.$deselectInput = group.querySelector('[data-deselect]')?.firstElementChild;
    }

    initialize () {
        this.setEvents();
    }

    toggleDisabled (input, disable) {
        const $label = input.parentNode.querySelector('label');

        if (disable) {
            input.disabled = true;
            input.checked = false;
            $label.classList.add('form__label--disabled');
        } else {
            input.disabled = false;
            $label.classList.remove('form__label--disabled');
        }
    }

    setEvents () {
        if (this.$deselectInput) {
            this.$deselectInput.addEventListener('change', () => {
                if (this.$deselectInput.checked) {
                    this.$allInputs.forEach((input) => {
                        input.checked = false;
                        this.toggleDisabled(input, false);
                    });
                    this.$deselectInput.checked = true;
                }
            });
        }

        this.$allInputs.forEach((input) => {
            input.addEventListener('change', () => {
                if (input.checked && input.parentElement.getAttribute('data-deselect') === null) {
                    if (this.$deselectInput) {
                        if (this.$deselectInput.checked) {
                            this.$deselectInput.checked = false;
                        }
                    }
                }

                // Enable/disable all 'obstruction options' if 'no obstruction' is unchecked/checked
                if (input.id === 'co_creation_handicapped_0') {
                    for (let index = 0; index < this.$allInputs.length; index++) {
                        if (this.$allInputs[index] !== input && this.$allInputs[index].id !== 'co_creation_handicapped_1' && this.$allInputs[index].id !== 'co_creation_handicapped_7') {
                            this.toggleDisabled(this.$allInputs[index], input.checked);
                        }
                    }
                }

                // Enabled/disable 'no obstruction' if at least 1 obstruction option is checked
                if (input.id !== 'co_creation_handicapped_0' || input.id !== 'co_creation_handicapped_1' || input.id !== 'co_creation_handicapped_7') {
                    let counter = 0;

                    for (let index = 0; index < this.$allInputs.length; index++) {
                        if (this.$allInputs[index].checked && this.$allInputs[index].id !== 'co_creation_handicapped_0' && this.$allInputs[index].id !== 'co_creation_handicapped_1' && this.$allInputs[index].id !== 'co_creation_handicapped_7') {
                            counter++;
                        }
                    }

                    for (let index = 0; index < this.$allInputs.length; index++) {
                        if (this.$allInputs[index].id === 'co_creation_handicapped_0') {
                            this.toggleDisabled(this.$allInputs[index], counter > 0);
                        }
                    }
                }
            });
        });
    }
}

export { CoCreation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $deselectGroup = $context.querySelectorAll('[data-deselect-group="root"]');
        if ($deselectGroup.length > 0) {
            for (let i = 0; i < $deselectGroup.length; i++) {
                const creationForm = new CoCreation($deselectGroup[i]);
                creationForm.initialize();
            }
        }
    }
});
